<template>
  <div class="campanha list-campaign">
    <InfoProjectCard
      ref="infoProject"
      @simulation="landingPageOptions.simulationDrawer = !landingPageOptions.simulationDrawer"
    ></InfoProjectCard>

    <!-- MODAL DE PRODUTOS DE DOAÇÃO ######################### -->
    <DonationProductsList ref="listProductsDialog" :campaignLandingPage="campaignLandingPageConfig"></DonationProductsList>

    <section class="bloco projetos bg-theme-white" data-title="Projetos" ref="projetcsBlock">
      <div class="bloco-content">
        <h1 class="title-project-list">Conheça os projetos da campanha</h1>
        <div class="filter-list-project">
          <div>
            <input
              type="text"
              placeholder="Buscar"
              v-model="inputSearch"
              v-on:keyup.enter="searchProjects()"
            />
            <button @click="searchProjects()" class="white--text">
              <Icon name="fal fa-search" size="18" />
            </button>
          </div>
          <div class="filter-modify select-list-project">
            <div class="display-flex">
              <InputSelect
                :items="sortItems"
                v-model="selectedSort"
                @input="sortProjects()"
                unselectedText="ORDENAR POR"
                :useAnotherDefaultValue="true"
                valueAttribute="id"
                textAttribute="description"
                class="right-select"
              ></InputSelect>
            </div>
          </div>
        </div>

        <div class="wrapper mt-5 father-box-replace-project bg-projeto-white">
          <!-- Filtros no mesmo pill da vitrine de vagas: o VolunteeringFilterSelect e as
               classes volunteer-filter-* entraram na main e ja resolvem largura por
               conteudo e quebra de linha. Reaproveitar em vez de manter o InputSelect
               antigo deixa as duas telas com o mesmo filtro.

               O v-layout w-100 em volta nao e enfeite: o .wrapper desta secao e flex e os
               cards de projeto sao irmaos deste bloco -- sem forcar largura total, a barra
               de filtros divide a linha com os primeiros cards. -->
          <v-layout row wrap w-100>
            <div class="volunteer-filters">
              <div class="volunteer-filter-bar">
                <VolunteeringFilterSelect
                  label="Causa"
                  allText="Todas as causas"
                  multiple
                  :items="causeFilterItems"
                  :value="selectedCauses"
                  @input="onCauseFilterChange"
                />
                <VolunteeringFilterSelect
                  label="Abrangência"
                  allText="Todas as abrangências"
                  :items="coverageFilterItems"
                  :value="selectedCoverage"
                  @input="onCoverageFilterChange"
                />
              </div>
              <!-- Causas escolhidas, logo abaixo da barra e dentro do mesmo bloco, para
                   acompanhar a largura dos filtros. -->
              <div v-if="selectedCauses.length" class="project-cause-chips">
                <v-chip
                  v-for="causeId in selectedCauses"
                  :key="'cause-chip-' + causeId"
                  small
                  close
                  color="#02ACB4"
                  text-color="white"
                  class="ma-0"
                  @input="removeCause(causeId)"
                >{{ causeNameById(causeId) }}</v-chip>
              </div>
            </div>
          </v-layout>
          <template>
            <div
              class="box-replace-project"
              v-for="(project, i) in filteredProjects"
              :key="project.id"
              v-show="i < projectsToShowWhenNotListingAll || showAllProjects"
            >
              <div class="projeto">
                <div class="main-img">
                  <a
                    href="javascript:;"
                    @click="showLocationBox(project.id)"
                    class="map-marker-project"
                    title="Abrangência do Projeto"
                    v-if="project.coverageList.length > 0"
                  >
                    <Icon name="fas fa-map-marker-alt" size="16" />
                  </a>
                  <FileImage :file="project.projectLandingPageConfig.heroFile" />
                </div>
                <div class="logo-inst" v-show="project.institution.file != null">
                  <FileImage :file="project.institution.file" />
                </div>
                <div class="project-type">
                  <button
                    @click="openInfoDialog(project.projectTypeId)"
                    class="color-theme-primaria"
                  >
                    {{ project.projectTypeId == ProjectTypes.ProjetoIncentivado ? 'Incentivado' : project.projectTypeId == ProjectTypes.ProjetoSemIncentivoFiscal ? 'Sem Incentivo' : 'Ticket' }}
                    <Icon name="fal fa-info-circle" class="ml-2" size="18" />
                  </button>
                </div>
                <div class="content">
                  <h5>{{project.institution.entity.name}}</h5>
                  <h3 :title="project.shortName">{{project.shortName}}</h3>
                  <h6 class="mb-0">
                    <span :title="causeNames(project)">{{ causeNames(project) }}</span> &nbsp;&nbsp;|&nbsp;&nbsp;
                    <span title="Público" v-if="project.targetAudience">{{project.targetAudience.name}}</span>
                  </h6>
                  <!-- <span class="f-size-12">{{getCoverageName(project.coverageList)}}</span> Abrangência ão é aqui-->
                  <p
                    :title="project.objective"
                  >{{commonHelper.getSubstring(project.objective, 170)}}</p>
                  <v-layout justify-space-between>
                    <v-flex shrink>
                      <small>
                        Captação total:
                        <b
                          :title="'R$ ' + formatterHelper.formatMoney(project.totalDonatedValueWithCapturedValue, 0)"
                        >R$ {{formatterHelper.formatShortNumber(project.totalDonatedValueWithCapturedValue, 1)}}</b>
                      </small>
                    </v-flex>
                    <v-flex shrink>
                      <small>
                        Objetivo:
                        <b
                          :title="'R$ ' + formatterHelper.formatMoney(project.totalValue, 0)"
                        >R${{formatterHelper.formatShortNumber(project.totalValue, 1)}}</b>
                      </small>
                    </v-flex>
                  </v-layout>
                  <div class="progress-bar">
                    <span
                      :style="{width:calculatePercentual(project.totalDonatedValueWithCapturedValue, project.totalValue)}"
                    ></span>
                  </div>
                  <!-- IF -- se R$0 não mostra -->
                  <div style="height:35px" class="mt-3">
                    <div v-if="project.totalDonatedValueOnlyForCampaign != 0">
                      <v-layout justify-space-between>
                        <v-flex shrink color-theme-destaque>
                          <small>
                            <!-- {{campaignLandingPageConfig.campaign.name}}: -->
                            Captado nesta campanha:
                            <b
                              :title="'R$ ' + formatterHelper.formatMoney(project.totalDonatedValueOnlyForCampaign, 0)"
                            >R$ {{formatterHelper.formatShortNumber(project.totalDonatedValueOnlyForCampaign, 1)}}</b>
                          </small>
                        </v-flex>
                      </v-layout>
                      <div class="progress-bar">
                        <span
                          :style="{width:calculatePercentual(project.totalDonatedValueOnlyForCampaign, project.totalValue)}"
                          class="bg-theme-destaque"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <!-- end if R$0 -->

                  <v-layout mt-4>
                    <v-flex shrink>
                      <button
                        color="white"
                        class="btn-primary ml-0 mr-3 px-4 flat round"
                        v-if="project.captureStatus && showDonationButton"
                        :disabled="checkIfProjectAlreadyExistInTheCart(project) || (project.projectTypeId == ProjectTypes.Ticket && project.donationProductList && project.donationProductList.length == 0)"
                        large
                        @click="addProjectOrOpenDonationProductModal(project)"
                      >{{campaignLandingPageConfig ? campaignLandingPageConfig.donationButtonText : 'Quero doar'}}</button>
                      <button
                        color="white"
                        class="btn-default ml-0 mr-3 px-4 flat round"
                        v-if="project.captureStatus"
                        large
                        @click="gotoProjectLP(project.slug || project.id)"
                      >Saiba mais</button>
                    </v-flex>
                    <!--<v-flex shrink>
                  <v-btn flat round class="btn-white ml-0 ma-0 px-4" large>Saiba mais</v-btn>
                    </v-flex>-->
                  </v-layout>
                </div>
                <div class="footer">
                  <v-layout justify-end align-right>
                    <!--<v-flex shrink>
                  Doaram:
                  <b>2.543</b>
                </v-flex>
                <v-flex shrink>
                  Visto por:
                  <b>23.509</b>
                    </v-flex>-->
                    <v-flex shrink>
                      Beneficiários diretos
                      <span
                        class="badge"
                        title="1200"
                      >{{project.directBeneficiaries | FormatNumber}}</span>
                    </v-flex>
                    <!-- <v-flex shrink>
                  Beneficiários indiretos
                  <span class="badge">{{project.indirectBeneficiaries}}</span>
                    </v-flex>-->
                  </v-layout>
                </div>
                <div class="apoiadores">
                  <v-layout justify-end align-right>
                    <v-flex shrink>
                      <span
                        v-if="!getSelectedCompaines(project.projectLandingPageConfig, true)"
                      >Apoio: {{campaignLandingPageConfig.campaign.company.entity.name}}</span>
                      <span
                        v-else
                        :title="getSelectedCompaines(project.projectLandingPageConfig, false)"
                      >{{getSelectedCompaines(project.projectLandingPageConfig, true)}}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <template>
                  <!-- :class="active" -->
                  <div
                    :ref="'locationBox'+project.id"
                    class="overlay-location-project"
                    @click="hideLocationBox(project.id)"
                  >
                    <div class="info-location-project">
                      <a
                        href="javascript:;"
                        class="close-location-project"
                        @click="hideLocationBox(project.id)"
                      >
                        <Icon name="fal fa-times" size="18" colorFont="#80849A" />
                      </a>
                      <h2>Abrangência</h2>
                      <ul>
                        <li v-for="coverage in project.coverageList" :key="coverage.id">
                          <Icon name="fal fa-map-marker-alt" size="20" class="mr-3" />
                          {{coverage.name}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div
          class="button-show-more-projects py-3"
          v-if="!showAllProjects && filteredProjects!=null && filteredProjects.length > projectsToShowWhenNotListingAll"
        >
          <button class="btn-ghost-primary v-btn--large" @click="showAllProjects = true">
            <span>Mostrar mais</span>
            <span class="badge">{{filteredProjects.length - projectsToShowWhenNotListingAll}}</span>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>
<script type="plain/text">
import BorderSeparation from "@/components/BorderSeparation.vue";
import FileProjectImage from "@/components/FileProjectImage.vue";
import DonationProductsList from "@/components/DonationProductsList.vue";
import ProjectGalleryView from "@/components/ProjectGalleryView.vue";
import ProjectContactLP from "@/components/ProjectContactLP.vue";
import { FileType } from "@/scripts/models/enums/fileType.enum";
import FileProject from "@/scripts/models/fileProject.model";
import ProjectLandingPageConfig from "@/scripts/models/projectLandingPageConfig.model";
import CampaignLandingPageOptions from "@/scripts/models/campaignLandingPageOptions.model";
import Project from "@/scripts/models/project.model";
import ProjectService from "@/scripts/services/project.service";
import FileService from "@/scripts/services/file.service";
import FileProjectService from "@/scripts/services/fileProject.service";
import CampaignService from "@/scripts/services/campaign.service";
import { Routes } from "@/scripts/models/enums/routes.enum.js";
import FileImage from "@/components/FileImage.vue";
import InfoProjectCard from "@/components/InfoProjectCard.vue";
import {
  ProjectTypes,
  GetProjectTypeName
} from "@/scripts/models/enums/projectTypes.enum.js";
import { ProjectPhasesText } from "@/scripts/models/enums/projectPhases.enum.js";
import { CampaignPhases } from "@/scripts/models/enums/campaignPhases.enum";
import FormatterHelper from "@/scripts/helpers/formatter.helper";
import CommonHelper from "@/scripts/helpers/common.helper";
import { coverageKey, uniqueCoverages } from "@/scripts/helpers/coverage.helper";
import CampaignLandingPageConfig from "@/scripts/models/campaignLandingPageConfig.model";
import { Causes } from "@/scripts/models/enums/causes.enum";
import { mapGetters, mapActions } from "vuex";
import VolunteeringFilterSelect from "@/components/volunteering/VolunteeringFilterSelect.vue";
export default {
  components: {
    VolunteeringFilterSelect,
    BorderSeparation,
    FileProjectImage,
    DonationProductsList,
    ProjectGalleryView,
    ProjectContactLP,
    FileImage,
    InfoProjectCard
  },
  props: ["projectId", "landingPageOptions"],
  data() {
    return {
      projectsToShowWhenNotListingAll: 6,
      showAllProjects: false,
      tab: null,
      edit: false,
      items: ["Appetizers", "Entrees", "Deserts", "Cocktails"],
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      fileType: FileType,
      filteredProjects: [],
      causeList: [],
      coverageList: [],
      sortItems: [
        { id: "project", description: "Projeto", desc: false },
        { id: "institution", description: "Instituição", desc: false },
        {
          id: "objective",
          description: "Objetivo do Projeto (R$)",
          desc: true
        },
        {
          id: "capturedMax",
          description: "Maior Valor Arrecadado (R$)",
          desc: true
        },
        {
          id: "capturedMin",
          description: "Menor Valor Arrecadado (R$)",
          desc: false
        }
      ],
      ageRangeList: [],
      commonHelper: CommonHelper,
      project: new Project(),
      projectLP: new ProjectLandingPageConfig(),
      projectService: new ProjectService(),
      fileProject: new FileProject(),
      fileProjectService: new FileProjectService(),
      fileService: new FileService(),
      formatterHelper: new FormatterHelper(),
      campaignService: new CampaignService(),
      campaignLandingPageConfig: new CampaignLandingPageConfig(),
      selectedFileProjectId: null,
      project: {
        type: "Galeria de Fotos"
      },
      targetAudienceList: [],
      getProjectTypeName: GetProjectTypeName,
      ProjectTypes: ProjectTypes,
      projectPhasesText: ProjectPhasesText,
      // Causas escolhidas no filtro. Array vazio = todas.
      selectedCauses: [],

      selectedCoverage: null,
      selectedSort: "",
      inputSearch: "",
      sortDescending: false,
      showDonationButton: false
    };
  },
  beforeRouteEnter: (to, from, next) => {
    let campaignService = new CampaignService();
    campaignService
      .getCampaignLandingPageConfigByCampaignIdWithoutCarts(to.query.campaignId)
      .then(function(data) {
        to.query.campaignLandingPageConfig = data;
        to.query.causeId = to.query.causeId;
        to.query.coverage = to.query.coverage;
        next();
      });
  },
  created() {
    this.campaignLandingPageConfig = this.$route.query.campaignLandingPageConfig;

    // causeIds é a forma nova, várias separadas por vírgula. causeId continua sendo lido
    // porque links antigos e favoritos mandam só ele.
    if (this.$route.query.causeIds) {
      this.selectedCauses = String(this.$route.query.causeIds)
        .split(",")
        .map((id) => parseInt(id))
        .filter((id) => !isNaN(id));
    } else if (this.$route.query.causeId) {
      const causeId = parseInt(this.$route.query.causeId);
      if (!isNaN(causeId)) this.selectedCauses = [causeId];
    }
    if (this.$route.query.coverage)
      this.selectedCoverage = this.$route.query.coverage;

    if (
      this.campaignLandingPageConfig &&
      this.campaignLandingPageConfig.campaign &&
      this.campaignLandingPageConfig.campaign.file
    ) {
      this.showDonationButton =
        CommonHelper.getSubdomain() != null &&
        this.campaignLandingPageConfig.campaign.campaignPhaseId ==
          CampaignPhases.EmAndamento &&
        this.campaignLandingPageConfig.campaign.published;

      this.$set(
        this.landingPageOptions,
        "logo",
        this.campaignLandingPageConfig.campaign.file
      );
    }

    this.campaignService
      .getCampaignProjectList(this.campaignLandingPageConfig.campaign.id)
      .then(this.campaignService_getCampaignProjectListCallback);
    // this.fillCausesAndCoveragesList(this.campaignLandingPageConfig.projectList);
    // this.searchProjects();
  },
  computed: {
    ...mapGetters(["alreadyExistsInCart"]),
    /**
     * Causas que ainda nao foram escolhidas.
     *
     * O <select> nao oferece o que ja esta como chip: escolher de novo nao faria nada e
     * so daria a impressao de que o filtro travou.
     */
    /**
     * Opções no formato { text, value } que o VolunteeringFilterSelect espera.
     *
     * Todas as causas, inclusive as já escolhidas: no pill, clicar de novo numa opção
     * marcada é como se desmarca.
     */
    causeFilterItems() {
      return this.causeList.map((cause) => ({ text: cause.name, value: cause.id }));
    },
    coverageFilterItems() {
      return this.coverageList.map((coverage) => ({
        text: coverage.name,
        value: coverage.name,
      }));
    }
  },
  methods: {
    ...mapActions(["addToCart"]),
    showLocationBox(projectId) {
      var ref = this.$refs["locationBox" + projectId];
      if (ref) ref[0].classList.add("active");
    },
    openInfoDialog(projectType) {
      this.$refs.infoProject.open(projectType);
    },
    hideLocationBox(projectId) {
      var ref = this.$refs["locationBox" + projectId];
      if (ref) ref[0].classList.remove("active");
    },
    showLocationBox(projectId) {
      var ref = this.$refs["locationBox" + projectId];
      if (ref) ref[0].classList.add("active");
    },
    campaignService_getCampaignProjectListCallback(data) {
      let campaignCause = data.filter(
        el => el.cause.id == Causes.DoacaoParaCampanha
      );
      campaignCause.forEach(el => {
        let index = data.indexOf(el);
        data.splice(index, 1);
      });
      this.campaignLandingPageConfig.projectList = CommonHelper.shuffleArray(
        data
      );
      campaignCause.forEach(el => {
        this.campaignLandingPageConfig.projectList.unshift(el);
      });
      this.searchProjects();
    },
    /**
     * O pill devolve a lista inteira já pronta, inclusive vazia quando o usuário escolhe
     * "Todas as causas" -- então aqui é só guardar e refiltrar.
     */
    onCauseFilterChange(value) {
      this.selectedCauses = Array.isArray(value) ? value : [];
      this.searchProjects();
    },
    onCoverageFilterChange(value) {
      this.selectedCoverage = value || null;
      this.searchProjects();
    },
    removeCause(causeId) {
      this.selectedCauses = this.selectedCauses.filter((id) => id !== causeId);
      this.searchProjects();
    },
    causeNameById(causeId) {
      const cause = this.causeList.find((item) => item.id === causeId);
      return cause ? cause.name : "";
    },
    /**
     * Ids das causas do projeto.
     *
     * causeIdList vem do back-end desde a V1_1_207. O fallback para cause.id cobre
     * payload de endpoint que ainda nao preenche a lista -- sem ele o projeto sumiria de
     * qualquer filtro de causa.
     */
    projectCauseIds(project) {
      if (project.causeIdList && project.causeIdList.length)
        return project.causeIdList;
      return project.cause ? [project.cause.id] : [];
    },
    /**
     * Nomes das causas do projeto, para o card. Concatenados em vez de chips: aquela
     * linha do card divide espaco com o publico-alvo e ja e apertada.
     */
    causeNames(project) {
      if (project.causeList && project.causeList.length)
        return project.causeList.map((cause) => cause.name).join(", ");
      return project.cause ? project.cause.name : "";
    },
    campaignService_getProjectCauseListCallback(data) {
      this.causeList = data;
    },
    campaignService_getProjectCoverageListCallback(data) {
      this.coverageList = uniqueCoverages(data || []);
    },
    // fillCausesAndCoveragesList(projectList) {
    //   this.causeList = projectList.map(project => project.cause);
    //   this.causeList = Array.from(
    //     new Set(this.causeList.map(cause => cause.id))
    //   ).map(causeId => this.causeList.find(cause => cause.id == causeId));

    //   this.coverageList = projectList
    //     .map(project => project.coverageList)
    //     .flat();
    //   this.coverageList = Array.from(
    //     new Set(this.coverageList.map(coverage => coverage.name))
    //   ).map(coverageName =>
    //     this.coverageList.find(coverage => coverage.name == coverageName)
    //   );

    //   this.coverageList.sort((a, b) => {
    //     if (a.name > b.name) return 1;
    //     else if (a.name < b.name) return -1;
    //     return 0;
    //   });
    //   this.causeList.sort((a, b) => {
    //     if (a.name > b.name) return 1;
    //     else if (a.name < b.name) return -1;
    //     return 0;
    //   });
    // },
    addProjectOrOpenDonationProductModal(item) {
      if (item.donationProductList.length == 0) {
        this.addCartItem(item);
        document.getElementById("animation-proj").classList.add("active");
        setTimeout(() => {
          document.getElementById("animation-proj").classList.remove("active");
        }, 2000);
      } else {
        if (Array.isArray(this.$refs.listProductsDialog))
          this.$refs.listProductsDialog[0].open(item);
        else this.$refs.listProductsDialog.open(item);
      }
    },
    addCartItem(project) {
      var cartItem = {
        project: project
      };
      this.addToCart(cartItem);
    },
    checkIfProjectAlreadyExistInTheCart(project) {
      if (project && project.donationProductList.length == 0)
        return this.alreadyExistsInCart({ project: project });
      return false;
    },
    gotoCart() {
      this.$router.push({ name: Routes.web.CartLogged });
    },
    gotoProjectLP(idOrSlug) {
      this.$router.push({
        name: Routes.web.ProjectLP,
        params: { idOrSlug: idOrSlug }
      });
    },
    getSelectedCompaines(projectLandingPageConfig, onlyTwo) {
      var result = "";
      if (projectLandingPageConfig && projectLandingPageConfig.project) {
        var campaignProjectList =
          projectLandingPageConfig.project.campaignProjectList;
        if (campaignProjectList && campaignProjectList.length > 0) {
          for (let i = 0; i < campaignProjectList.length; i++) {
            var campaignProjectCompanyList =
              campaignProjectList[i].campaignProjectCompanyList;
            if (
              campaignProjectCompanyList &&
              campaignProjectCompanyList.length > 0
            ) {
              for (let j = 0; j < campaignProjectCompanyList.length; j++) {
                if (
                  campaignProjectCompanyList[j].company &&
                  campaignProjectCompanyList[j].company.entity
                ) {
                  if (result == "") {
                    result =
                      "Apoio: " +
                      campaignProjectCompanyList[j].company.entity.name;
                  } else if (onlyTwo) {
                    if (j < 2)
                      result +=
                        ", " +
                        campaignProjectCompanyList[j].company.entity.name;
                    else {
                      result += ", ...";
                      j = campaignProjectCompanyList.length;
                    }
                  } else {
                    result +=
                      ", " + campaignProjectCompanyList[j].company.entity.name;
                  }
                }
              }
            }
          }
        }
      }
      return result;
    },
    searchProjects() {
      this.filteredProjects = this.campaignLandingPageConfig.projectList.filter(
        project => {
          let apoiadores =
            this.campaignLandingPageConfig.campaign.company.entity.name +
            this.getSelectedCompaines(project.projectLandingPageConfig, false);
          let textSearch =
            project.institution.entity.name +
            project.shortName +
            apoiadores.replace("Apoio: ", "");
          return (
            (!this.selectedCoverage ||
              project.coverageList.some(
                coverage => coverageKey(coverage.name) === coverageKey(this.selectedCoverage)
              )) &&
            (!this.selectedCauses.length ||
              this.projectCauseIds(project).some((id) =>
                this.selectedCauses.includes(id)
              )) &&
            (this.inputSearch == "" ||
              textSearch.toLowerCase().includes(this.inputSearch.toLowerCase()))
          );
        }
      );
      let campaignCause = this.filteredProjects.filter(
        el => el.cause.id == Causes.DoacaoParaCampanha
      );
      campaignCause.forEach(el => {
        let index = this.filteredProjects.indexOf(el);
        this.filteredProjects.splice(index, 1);
      });
      campaignCause.forEach(el => {
        this.filteredProjects.unshift(el);
      });

      // this.fillCausesAndCoveragesList(this.filteredProjects);
      if (this.selectedCoverage == "") this.selectedCoverage = null;
      this.campaignService
        .getProjectCauseList(
          this.campaignLandingPageConfig.campaign.id,
          this.selectedCoverage
        )
        .then(this.campaignService_getProjectCauseListCallback);

      this.allowCoverageSearch = false;
      // GetProjectCoverageList só aceita uma causa. Com várias escolhidas, manda 0 e a
      // lista de abrangências volta completa, em vez de estreitada por uma causa
      // arbitrária das selecionadas. Estender aquele endpoint para lista fica para
      // depois -- ele estreita um filtro secundário, não a listagem de projetos.
      this.campaignService
        .getProjectCoverageList(
          this.campaignLandingPageConfig.campaign.id,
          this.selectedCauses.length === 1 ? this.selectedCauses[0] : 0
        )
        .then(this.campaignService_getProjectCoverageListCallback);
    },
    calculatePercentual(current, total, minimum = 0, maximum = 100) {
      let v = 0;
      if (total > 0) {
        v = Math.round((current / total) * 100);
        if (v < 100) v = Math.min(maximum, Math.max(minimum, v));
        else if (v > 100) v = 100;
      }
      return v + "%";
    },
    sortProjects() {
      if (this.selectedSort == "project") {
        this.filteredProjects.sort((a, b) => {
          if (a.fullName > b.fullName) return this.sortDescending ? -1 : 1;
          else if (a.fullName < b.fullName) return this.sortDescending ? 1 : -1;
          return 0;
        });
      }

      if (this.selectedSort == "institution") {
        this.filteredProjects.sort((a, b) => {
          if (a.institution.entity.name > b.institution.entity.name)
            return this.sortDescending ? -1 : 1;
          else if (a.institution.entity.name < b.institution.entity.name)
            return this.sortDescending ? 1 : -1;
          return 0;
        });
      }

      if (
        this.selectedSort == "capturedMax" ||
        this.selectedSort == "capturedMin"
      ) {
        this.sortDescending = this.selectedSort == "capturedMax" ? false : true;
        this.filteredProjects.sort((a, b) => {
          if (
            a.totalDonatedValueWithCapturedValue >
            b.totalDonatedValueWithCapturedValue
          )
            return this.sortDescending ? 1 : -1;
          else if (
            a.totalDonatedValueWithCapturedValue <
            b.totalDonatedValueWithCapturedValue
          )
            return this.sortDescending ? -1 : 1;
          return 0;
        });
      }

      if (this.selectedSort == "objective") {
        this.filteredProjects.sort((a, b) => {
          if (a.totalValue > b.totalValue) return this.sortDescending ? 1 : -1;
          else if (a.totalValue < b.totalValue)
            return this.sortDescending ? -1 : 1;
          return 0;
        });
      }
    }
  }
};
</script>

<style scoped>
/* Barra de filtros no mesmo pill da vitrine de vagas.

   As classes volunteer-filter-* nasceram no CampaignLandingPage.vue, mas o <style> de la
   e scoped, entao nao alcancam esta tela -- precisam existir aqui. Copia, e nao import de
   arquivo comum, para nao mover CSS de outra tela nesta entrega; se um terceiro consumidor
   aparecer, vale extrair para um .styl compartilhado. */
.volunteer-filters {
  max-width: 96rem;
  margin: 3rem auto 2rem;
  padding: 0 1.5rem;
}

.volunteer-filter-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

/* Chips das causas escolhidas: logo abaixo da barra e no mesmo bloco, para acompanhar a
   largura dos filtros em vez de esticar pela pagina. */
.project-cause-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.6rem;
  margin-top: 1rem;
}

@media (max-width: 768px) {
  .volunteer-filters {
    margin: 2rem auto 1.6rem;
  }

  .volunteer-filter-bar {
    justify-content: flex-start;
    gap: 0.8rem;
  }

  .project-cause-chips {
    justify-content: flex-start;
  }
}
</style>
